import hudlLogo from "../assets/images/logos/hudl.png";
import nimbusLogo from "../assets/images/logos/nimbus.png";
import sandhillsLogo from "../assets/images/logos/sandhills.png";
import unlLogo from "../assets/images/logos/unl.png";
import badgePhoto from "../assets/images/LandenBadge.jpg";

import chapterCheckImg from "../assets/images/ChapterCheckSite.png";
import catanImg from "../assets/images/CatanSite.png";
import pipelineImg from "../assets/images/Pipeline.png";
import portfolioImg from "../assets/images/PersonalPortfolio.png";
import hudlSiteImg from "../assets/images/HudlSite.png";

export const profile = {
  name: "Landen Fogle",
  badgePhoto,
  links: [
    { label: "GitHub", href: "https://github.com/landenf" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/landen-fogle/" },
    {
      label: "CV",
      href: "https://drive.google.com/file/d/1tekiq_4MNzeSvo9bTki60YQFU8LQka53/view?usp=sharing",
    },
  ],
};

export const experiences = [
  {
    id: "dineu",
    company: "DineU Delivery",
    role: "CEO & Co-Founder",
    stack: "React, Java, Node, AWS",
    timeframe: "2025 – Present",
    href: "https://dineu.app",
    logo: "https://dineu.app/assets/dineu-web-icon-BEy7AcMC.png",
    logoWide: false,
    blurb:
      "Building a campus food-delivery platform with serverless AWS infra, university partnerships, and early VC-backed growth.",
  },
  {
    id: "hudl",
    company: "Hudl",
    role: "Software Engineer",
    stack: ".NET, AWS, React, DocDB",
    timeframe: "2024 – Present",
    href: "https://www.hudl.com",
    logo: hudlLogo,
    logoWide: false,
    blurb:
      "Software engineer on a product team shipping features used by customers every day.",
  },
  {
    id: "nimbus",
    company: "NIMBUS Lab",
    role: "Undergraduate Researcher",
    stack: "Python, Docker, ROS",
    timeframe: "2023 – 2025",
    href: "https://nimbus.unl.edu",
    logo: nimbusLogo,
    logoWide: true,
    blurb:
      "Containerized PHM tooling for UAV swarm agents and AIAA research on pre-flight anomaly detection.",
  },
  {
    id: "sandhills",
    company: "Sandhills Global",
    role: "Software Developer Intern",
    stack: ".NET, React, Azure",
    timeframe: "Summer 2023",
    href: "https://www.sandhills.com",
    logo: sandhillsLogo,
    logoWide: true,
    blurb:
      "Shipped domestic site features, ADA compliance (~95%), SEO lifts, and an advertising inquiry workflow.",
  },
];

export const research = [
  {
    id: "phm",
    title:
      "Integrated Prognostics and Health Monitoring Tool Aboard UAS Swarm Agents",
    venue: "AIAA 2023",
    linkLabel: "Paper",
    href: "https://drive.google.com/file/d/1MO7VDwXW8zQBhl6yLrhDDYFmg0eGwH5V/view",
  },
  {
    id: "soccer",
    title:
      "Machine Learning Approach for Predicting Premier League Match Outcomes",
    venue: "2024",
    linkLabel: "Paper",
    href: "https://drive.google.com/file/d/1mHwmy36THagb9surU00cf2duT0Q1c7Gs/view",
  },
  {
    id: "mmi",
    title: "Marcus & Millichap Equity Report",
    venue: "UNL 2022",
    linkLabel: "Link",
    href: "https://drive.google.com/file/d/1n0g9Act4mSZ-oqsMNUpFsyy60cCO_5Mj/view",
  },
];

export const featured = [
  {
    id: "chapter-check",
    title: "Chapter Check — SaaS for Greek orgs, mobile + web",
    date: "Dec 2023 – Present",
    image: chapterCheckImg,
    href: "https://mychaptercheck.com",
  },
  {
    id: "catan",
    title: "Online multiplayer Settlers of Catan",
    date: "Spring 2024",
    image: catanImg,
    href: "https://catan-4dea2.web.app/",
  },
  {
    id: "cicd",
    title: "CI/CD pipeline POC on AWS",
    date: "Spring 2023",
    image: pipelineImg,
    href: "https://github.com/landenf/CI-CD-Model",
  },
  {
    id: "portfolio",
    title: "Personal portfolio — React + Tailwind",
    date: "2024",
    image: portfolioImg,
    href: "https://github.com/landenf/Personal-Portfolio",
  },
  {
    id: "hudl-work",
    title: "Hudl intern — access management at scale",
    date: "Summer 2024",
    image: hudlSiteImg,
    href: "https://hudl.com",
  },
];

export const apps = [
  {
    id: "dineu-app",
    title: "DineU – Campus food delivery platform",
    href: "https://dineu.app",
    linkLabel: "Link",
    badge: "Live",
    description:
      "Microservice food delivery API for on-campus dining, AWS + Terraform, VC-backed pilot.",
    stack: "React Native, Java, AWS",
  },
  {
    id: "chapter-check-app",
    title: "Chapter Check – Greek org operations",
    href: "https://mychaptercheck.com",
    linkLabel: "Link",
    description:
      "Member management and geo attendance — React Native + moderator web.",
    stack: "React Native, Expo, Express, AWS, Terraform",
  },
  {
    id: "catan-app",
    title: "Catan – Multiplayer board game",
    href: "https://catan-4dea2.web.app/",
    linkLabel: "Link",
    description:
      "Real-time online Settlers of Catan with auth and websocket gameplay.",
    stack: "React, Express, WebSockets, AWS, Firebase",
  },
  {
    id: "space-shooter",
    title: "Space Shooter – FPS endless runner",
    href: "https://github.com/landenf/SpaceShooter2000",
    linkLabel: "GitHub",
    description: "FPS endless runner built in Unity.",
    stack: "C#, Unity",
  },
];

export const experiments = [
  {
    id: "cicd-exp",
    title: "CI/CD Pipeline POC",
    href: "https://github.com/landenf/CI-CD-Model",
    linkLabel: "GitHub",
    description:
      "End-to-end DevOps lifecycle demo: review → build → test → AWS deploy → staging approval.",
    stack: "Python, AWS",
  },
];

export const certifications = [
  {
    id: "aws-dev",
    title: "AWS Certified Developer – Associate",
    href: "https://aws.amazon.com/certification/certified-developer-associate/",
    linkLabel: "Link",
  },
  {
    id: "aws-ccp",
    title: "AWS Certified Cloud Practitioner",
    href: "https://aws.amazon.com/certification/certified-cloud-practitioner/",
    linkLabel: "Link",
  },
  {
    id: "faa",
    title: "FAA Part 107 Remote Pilot",
    href: "https://www.faa.gov/uas/commercial_operators/become_a_drone_pilot",
    linkLabel: "Link",
  },
];

export const education = [
  {
    id: "unl",
    company: "University of Nebraska–Lincoln",
    role: "B.S. Computer Science & B.A. Finance · Raikes School",
    stack: "",
    timeframe: "2022 – 2026",
    href: "https://www.unl.edu",
    logo: unlLogo,
    logoWide: false,
    blurb: "Jeffrey S. Raikes School of Computer Science and Management.",
  },
];
